import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import { CollectionDataSource } from 'managers/datasources/collection';
import { EffectsContainer } from 'mixins/withEffects';
import Participant from 'models/participant';
import { ServicesContext } from 'services/context';

export interface TopicParticipantsManagerConfig {
    topicId: string
    filter: string
}

@injectable()
export default class TopicParticipantsManager {
    private topicId: string
    private filter: string

    private source: CollectionDataSource<Participant>

    people: Subscribable<Array<Participant>>

    busy = ko.pureComputed(() => this.source.busy())
    loading = ko.pureComputed(() => this.source.busy() && this.source.requestsProcessed() === 0);
    updating = ko.pureComputed(() => this.source.busy() && this.source.requestsProcessed() > 0);

    constructor(
        @inject(wccModules.managerConfig) { topicId, filter }: TopicParticipantsManagerConfig,
        @inject(wccModules.servicesContext) private ctx: ServicesContext,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        this.topicId = topicId;
        this.filter = filter;

        this.source = effects.register(new CollectionDataSource({
            load: this.load.bind(this),
            mapper: jsonPerson => new Participant(jsonPerson)
        }));

        this.people = this.source.list;
    }

    private load() {
        const args: { [key: string]: string } = {};

        if (this.filter.length > 0)
            args['filter'] = this.filter;

        return this.ctx.peopleService.queries.topicParticipants(this.topicId).addArgs(args).toArray();
    }
}